import './Kontakt.css'
import kontakt from "../images/home/home9.jpg"
// import salon from
import "../fonts/fonts.css"

function Kontakt() {

    return (
        <div style={{paddingTop: "5rem"}}>
        <div className="big-container-contact font-tiskani">
            <div className="side-by-side">
                <div className="centered-container font-tiskani-kontakt padding-15 contact-container">
                    <div className="font-italic padding-down font-large">
                        Kontaktirajte nas
                    </div>
                    <div className=" padding-down">
                        Berislavićeva 15, 10000 Zagreb
                    </div>
                    <div className=" padding-down">
                        info@beautyboutique.hr
                    </div>
                    <div className=" padding-down">
                        091 7662 599
                    </div>
                </div>
            </div>

            <div className="side-by-side img-container">
                <img src={kontakt} className="img-max" alt="Jesi"/>
            </div>
        </div>

            <div>
                <div className="big-container-contact font-tiskani">
                    <div className="font-tiskani-kontakt padding-15 contact-container">
                    <div className="font-italic font-large padding-down">
                        Beauty Boutique d.o.o. za trgovinu i usluge
                    </div>
                    <div className="padding-down-manje">
                        OIB 02882437819
                    </div>
                    <div className="padding-down-manje">
                        Berislavićeva 15, 10000 Zagreb
                    </div>
                    <div className="padding-down-manje">
                        info@beautyboutique.hr
                    </div>
                    <div className="padding-down-manje">
                        091 7662 599
                    </div>
                    <div className="padding-down-manje">
                        Sud kod kojega je tvrtka upisana u Sudski registar: Trgovački sud u Zagrebu
                    </div>
                    <div className="padding-down-manje">
                        Broj pod kojim je tvrtka upisana u Sudski registar: MBS 081623900
                    </div>
                        <div className="padding-down-manje">
                            Otvoren račun u Privredna banka Zagreb d.d.
                        </div>
                        <div className="padding-down-manje">
                            Radnička cesta 50, 10 000 Zagreb, OIB:02535697732, SWIFT PBZGHR2X, IBAN HR6423400091000000013
                        </div>
                        <div className="padding-down-manje">
                            IBAN firme: HR2923400091111309404
                        </div>
                </div>
                </div>
            </div>

        {/*    <div className="contact-container">*/}
        {/*        <div className="container bg-light text-dark lmi-container">*/}
        {/*            <h2 className="naslov">Kontakt za prodaju</h2>*/}
        {/*            <p className="fontstyle" style={{marginTop: '20px'}}>LMI Consult, obrt za usluge</p>*/}
        {/*            <p className="fontstyle">Ime i prezime: Ljerka Juroš</p>*/}
        {/*            <p className="fontstyle">Email adresa: lmi-consult@outlook.com</p>*/}
        {/*        </div>*/}

        {/*        <div className="container bg-light text-dark projekt trnsko-container">*/}
        {/*            <h2 className="naslov" style={{marginBottom: '20px'}}>Informacije o investitoru:</h2>*/}
        {/*            <div>PROJEKT SLOBOŠTINA d.o.o.</div>*/}
        {/*            <div >Ulica Pavla Štoosa 27, 10 000 ZAGREB, Hrvatska</div>*/}
        {/*            <div>IBAN:HR3923600001502869847 Zagrebačka banka d.d.</div>*/}
        {/*            <div>OIB:24700429146</div>*/}

        {/*            <div>Upisano u Trgovački sud u Zagrebu</div>*/}
        {/*            <div>MBS:081385052</div>*/}
        {/*            <div>Temeljni kapital 20.000,00 kn uplaćen u cijelosti.</div>*/}
        {/*            <div>Članovi uprave: Krunoslav Juroš dipl.ing.građ.</div>*/}
        {/*            <div>Transakcijski računi: </div>*/}
        {/*            <ul>*/}
        {/*            <li>HR1223600001102944862 Zagrebačka banka d.d.</li>*/}
        {/*            </ul>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*    <div className="image-container">*/}
        {/*        <img src="images/Tabla.jpg" style={{maxHeight: '100%', maxWidth: '100%'}}/>*/}
        {/*    </div>*/}
        </div>


    );

}

export default Kontakt;